function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m350 80c-38.66 0-70 31.34-70 70v130h-130c-38.66 0-70 31.34-70 70s31.34 70 70 70h130v130c0 38.66 31.34 70 70 70s70-31.34 70-70v-130h130c38.66 0 70-31.34 70-70s-31.34-70-70-70h-130v-130c0-38.66-31.34-70-70-70z",
    fillRule: "evenodd",
    style: {
      fill: "#ffffff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.afc23c9c6d9c5a806a0d208d26928657.svg";
export { ForwardRef as ReactComponent };